import { Card } from "@/components/Card";
import React from "react";

export default function Landing() {
  return (
    <div className="gap-4">
      <Card
        to="/contact_center/custom_fields"
        title="Custom Fields"
        subtitle="Define custom fields and variables for contacts and conversations"
      />
      <Card
        to="/contact_center/contact-panel"
        title="Contact Panel"
        subtitle="Control which fields agents see in the contact sidebar during conversations"
      />
    </div>
  );
}
